import ForcePasswordChange from "./ForcePasswordChange";
import { useLocation } from "react-router-dom";
import AuthLayout from "../layouts/AuthLayout";
import { UIAlert } from "../../_app/components";
import { useMemo, useState } from "react";
import LoadingOverlay from "../../_app/components/LoadingOverlay";
import { useCurrentAuthUser } from "../hooks";
import PasswordResetDialog from "../components/cognito/PasswordResetDialog";
import CognitoSignIn from "../components/cognito/CognitoSignIn";
import SignInRedirect from "../components/SignInRedirect";

interface LocationState {
  isSsoRedirect?: boolean;
}

const Login = () => {
  const [isResetPasswordDialogOpen, setIsResetPasswordDialogOpen] = useState(false);
  const [username, setUsername] = useState("");
  const location = useLocation();
  const isInvite = location.pathname.includes("invite");
  const { user, isSessionChecked } = useCurrentAuthUser();
  const showBanner = useMemo(() => (location.state as LocationState)?.isSsoRedirect === true, [location.state]);

  const redirectAlert = useMemo(
    () => (
      <UIAlert severity="warning">
        Heads up! You came from our old login page. Save this new URL as your bookmark to avoid extra redirects.
      </UIAlert>
    ),
    [],
  );

  const handleRequirePasswordReset = (resetUsername: string) => {
    setUsername(resetUsername);
    setIsResetPasswordDialogOpen(true);
  };

  const renderContent = () => {
    if (isInvite) {
      return <ForcePasswordChange />;
    }

    return <CognitoSignIn onRequirePasswordReset={handleRequirePasswordReset} />;
  };

  // An already-signed-in user must not see the login page at all — hold rendering on a neutral
  // overlay until the session check resolves, then redirect straight into the app. The invite
  // flow is exempt: it serves its own force-password-change form.
  if (!isInvite) {
    if (user) return <SignInRedirect user={user} />;
    if (!isSessionChecked) return <LoadingOverlay />;
  }

  return (
    <>
      <PasswordResetDialog
        open={isResetPasswordDialogOpen}
        username={username}
        onClose={() => setIsResetPasswordDialogOpen(false)}
      />
      <AuthLayout title="Login" banner={showBanner ? redirectAlert : null}>
        {renderContent()}
      </AuthLayout>
    </>
  );
};

export default Login;
